import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

let {
    FileReader
} = ( /** @type {?} */((<any>window)));
export class ImagePreviewDirective implements OnChanges {

     image: any;
/**
 * @param {?} el
 */
constructor(private el: ElementRef) { }
/**
 * @return {?}
 */
ngOnChanges() {
        let /** @type {?} */ reader = new FileReader();
        let /** @type {?} */ el = this.el;

        // tslint:disable-next-line:max-line-length
        el.nativeElement.src = 'data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D\'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg\' viewBox%3D\'0 0 200 150\'%2F%3E';

        reader.onloadend = function () {
            el.nativeElement.src = reader.result;
        };

        if (this.image) {
            return reader.readAsDataURL(this.image.element);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{ selector: 'img[imgPreview]' }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'image': [{ type: Input },],
};
}

function ImagePreviewDirective_tsickle_Closure_declarations() {
/** @type {?} */
ImagePreviewDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ImagePreviewDirective.ctorParameters;
/** @type {?} */
ImagePreviewDirective.propDecorators;
/** @type {?} */
ImagePreviewDirective.prototype.image;
/** @type {?} */
ImagePreviewDirective.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
